export default __webpack_public_path__ + "images/c05d863c1a1f2b19645f79529991a327-expo.jpg";